import { get, flow, map } from 'lodash/fp';
import { createSelector, createStructuredSelector } from 'reselect';
import { getManualSeoSearchUrl } from 'helpers/namedUrls';
import {
  SEO_PAGE_CITY,
  SEO_PAGE_CITY_MAKE,
  SEO_PAGE_CITY_MODEL,
  SEO_PAGE_MAKE,
  SEO_PAGE_MODEL,
  SEO_PAGE_SUBTYPE,
} from '../../../../../../constants/seoPageType';

const pageTypeToTitles = (type, titles = []) => {
  const [make = '', model = '', subtype = ''] = titles;
  const base = { make: '', model: '', subtype: '', city: '' };

  switch (type) {
    case SEO_PAGE_MAKE:
      return { ...base, make };
    case SEO_PAGE_MODEL:
      return { ...base, make, model };
    case SEO_PAGE_SUBTYPE:
      return { ...base, make, model, subtype };
    case SEO_PAGE_CITY:
      return { ...base, city: make };
    case SEO_PAGE_CITY_MAKE:
      return { ...base, make, city: model };
    case SEO_PAGE_CITY_MODEL:
      return { ...base, make, model, city: subtype };
    default:
      return base;
  }
};

const getLinks = (field) => (_, props) =>
  createSelector(get([field]), get('linkType'), (links) => {
    return map((link) => {
      return {
        ...link,
        link: getManualSeoSearchUrl(link.url),
      };
    })(links);
  })(props);

const getTitles = flow(
  (state, props) => props,
  ({ linkType, breadcrumbs }) => ({
    type: linkType,
    titles: map(get(['title']), breadcrumbs),
  }),
  ({ type, titles }) => pageTypeToTitles(type, titles),
);

export default createStructuredSelector({
  cities: getLinks('cities'),
  cityMakesByCity: getLinks('cityMakesByCity'),
  cityMakesByMake: getLinks('cityMakesByMake'),
  cityModelsByCityMake: getLinks('cityModelsByCityMake'),
  cityModelsByCityModel: getLinks('cityModelsByCityModel'),
  cityModelsByModel: getLinks('cityModelsByModel'),
  cityModelsBySubtype: getLinks('cityModelsBySubtype'),
  makes: getLinks('makes'),
  models: getLinks('models'),
  subtypes: getLinks('subtypes'),
  titles: getTitles,
});
